import { Dropdown } from '@cimplico/components';
import StructuredTextCard from '../../../components/structured-text-card/StructuredTextCard';
import { Note } from '../../../types/note';
import { useDeleteNote } from '../../../queries/use-delete-note';
import { toastNotification } from '../../../components/toast/Toast';
import { useState } from 'react';
import { useUpdateNote } from '../../../queries/use-update-note';
import { useWorkpaperContext } from '../../../providers/WorkpaperProvider';

export default function NoteItem({ note, showContextBadge }: { note: Note; showContextBadge?: boolean }): JSX.Element {
    const [isEditing, setIsEditing] = useState(false);

    const { readOnly } = useWorkpaperContext();

    const deleteNoteQuery = useDeleteNote();
    function handleDeleteNote(): void {
        deleteNoteQuery.mutate(
            { id: note.id },
            {
                onError: (err) => {
                    toastNotification('error', 'Unable to delete note!', err.response?.data);
                },
            }
        );
    }

    const updateNoteQuery = useUpdateNote();
    function handleUpdateNote({
        rawContent,
        structuredContent,
    }: {
        rawContent: string;
        structuredContent?: { [key: string]: unknown };
    }): void {
        updateNoteQuery.mutate(
            { id: note.id, fields: { rawMessage: rawContent, structuredMessage: structuredContent } },
            {
                onSuccess: () => {
                    setIsEditing(false);
                },
                onError: (err) => {
                    setIsEditing(false);
                    toastNotification('error', 'Unable to edit note!', err.response?.data);
                },
            }
        );
    }

    return (
        <StructuredTextCard>
            <StructuredTextCard.Author createdAt={note.createdAt} createdBy={note.createdBy} />
            <Dropdown dotsDirection="horizontal" disabled={readOnly}>
                <Dropdown.Option label="Delete" onClick={handleDeleteNote} value="delete" />
                <Dropdown.Option label="Edit" onClick={(): void => setIsEditing(true)} value="edit" />
            </Dropdown>
            {showContextBadge && <StructuredTextCard.Badge label={note.context.label} color="indigo" />}

            <StructuredTextCard.Message
                isSaving={false}
                rawContent={note.rawMessage}
                structuredContent={note.structuredMessage || undefined}
                isEditing={isEditing}
                onCancel={(): void => {
                    setIsEditing(false);
                }}
                onUpdate={handleUpdateNote}
            />
        </StructuredTextCard>
    );
}
